import { gql } from '@apollo/client'

export const CREATE_BOOKING_HOURLY = gql`
    mutation BookingCreateBookingHourly(
        $email: String!
        $lot_id: String!
        $plates: [InputBookingPlate!]
        $duration_hours: Int!
        $total_amount: numeric!
        $shopper_locale: String!
    ) {
        booking_create_booking_hourly(
            email: $email
            lot_id: $lot_id
            plates: $plates
            duration_hours: $duration_hours
            total_amount: $total_amount
            shopper_locale: $shopper_locale
        ) {
            id
            booking_reference
            success
            unavailable_dates
        }
    }
`
